import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faPlus } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import { createIndexAdjustment } from "../../api/BillingGroups";
import toast from "react-hot-toast";
import Breadcrumbs from "../../components/Breadcrumbs";
import EditForm from "../../components/EditForm";

const CreateIndexAdjustmentPage = () => {
  const { getAccessToken, user } = useAuth();
  const { agreementPublicId } = useParams();
  const navigate = useNavigate();
  const [hasChanges, setHasChanges] = useState(false);
  const [indexAdjustment, setIndexAdjustment] = useState({
    agreementPublicId: agreementPublicId || "",  // Försök hämta från URL, annars tomt
    entraTenantId: "", 
    ingramCustomerId: 0, 
    displayName: "",
    domain: "",
  });

  const handleBackClick = () => {
    navigate(-1);
  };

const handleCreateIndexAdjustment = async () => {
  try {
    const accessToken = await getAccessToken();
    if (!accessToken) {
      toast.error("Authorization failed. Please log in again.");
      return;
    }

    // Kontrollera att alla fält är ifyllda
    if (!indexAdjustment.agreementPublicId) {
      toast.error("The index adjustment must be associated with an agreement.");
      return;
    }

    console.log("Sending IA Data:", indexAdjustment);

    await createIndexAdjustment(indexAdjustment, accessToken);
    
    toast.success("Index adjustment created successfully", {
      iconTheme: {
        primary: "#4CAF50",
        secondary: "#DFF2BF",
      },
    });
    
  } catch (error) {
    console.error("Failed to create index adjustment:", error);
    toast.error("Failed to create index adjustment");
  }
};

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="page-content">
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <button onClick={handleBackClick} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Create index adjustment</h2>
              <div className="flex gap-4 ml-auto">
                <button className="btn btn-outline-primary" onClick={handleBackClick}>
                  Cancel
                </button>
                <button className="btn btn-primary" disabled={!hasChanges} onClick={handleCreateIndexAdjustment}>
                Save
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
              <EditForm
                data={indexAdjustment}
                setData={setIndexAdjustment}
                setHasChanges={setHasChanges}
                disabled={false}
                fields={[
                  { key: "agreementPublicId", label: "Agreement ID", type: "text", disabled: true}, 
                  { key: "name", label: "Name", type: "text" },
                  { key: "indexFactor", label: "Index factor", type: "number" },
                ]}
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default CreateIndexAdjustmentPage;